import { PopoverButton, PopoverPanelProps } from "@headlessui/react";
import { cn } from "@portal/components/lib/utils";
import { Menu } from "@portal/components/ui/Menu";
import { ReactNode } from "react";
import { HiDotsVertical } from "react-icons/hi";

export const ToolContextMenu = ({
	children,
	anchor,
	testId,
}: {
	testId?: string;
	children: React.ReactNode;
	anchor?: PopoverPanelProps["anchor"];
}) => {
	return (
		<Menu
			testId={testId}
			button={<HiDotsVertical />}
			anchor={anchor ?? "left"}
			buttonClassName="h-[14px] w-[14px] cursor-pointer text-gray-400 hover:text-gray-800"
			panelClassName="flex flex-col items-start mt-6 w-[81px] bg-white border border-slate-100 rounded-md shadow-lg"
		>
			{children}
		</Menu>
	);
};

export const ToolContextMenuItem = ({
	testId,
	disabled,
	onClick,
	label,
}: {
	testId?: string;
	disabled?: boolean;
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	label: ReactNode;
}) => {
	return (
		<PopoverButton
			data-testid={testId}
			className={cn(
				"flex justify-start p-[10px] cursor-pointer hover:bg-gray-50 text-[12px] w-full",
				disabled && "text-gray-300 cursor-default hover:text-gray-300",
			)}
			onClick={(e) => {
				if (!disabled) {
					onClick(e);
				}
			}}
		>
			{label}
		</PopoverButton>
	);
};
